import styled from "styled-components";
import { common } from "@mui/material/colors";
//import { palette } from "../../../../shared/styles/theme"

const bg_sign = require("../../../../assets/sign-bg.png");

export const BackgroundSignStyle = styled.div`
  width: 100%;
  height: 100vh;
  background-image: url(${bg_sign});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  overflow: hidden;

  .bg-black {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    width: 100%;
    height: 100vh;
  }

  .div-card {
    margin: 0 20px;
    padding: 3%;
    border: none;
  }

  p {
    color: ${common.black};
    text-transform: uppercase;
    text-align: center;
    font-size: 1.5rem;
    font-weight: bold;
  }

  .backgroundSign {
    background-image: url(${bg_sign});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    width: 100%;
    height: 100vh;
  }
`;
